import previewAttachmentPlus from './previewAttachmentPlus.vue'
export default previewAttachmentPlus
